import { render, staticRenderFns } from "./ManageCourses.vue?vue&type=template&id=62eaf21d"
import script from "./ManageCourses.vue?vue&type=script&lang=ts"
export * from "./ManageCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports